import { createAsyncThunk } from "@reduxjs/toolkit";
import * as PostServiceApi from "apis/PostServiceApi";
import { ThunkAPI } from "store/types";
import { selectUserId } from "store/user/user.selectors";
import { setUserPosts } from "./userPosts.slice";


export const fetchUserPosts = createAsyncThunk<
void,
void,
ThunkAPI
>(
  "userPosts/fetchUserPosts",
  async (_, thunkAPI) => {
    try {
      const state = thunkAPI.getState()
      const userId = selectUserId(state);
      
      const response = await PostServiceApi.getPostsByUserId(userId);

      const processedResponse = response.values.map(
        (value) => {
        const post = value.data[0]
        const {id,images,post_caption} = post
        const postToSelect = {
         id,
         post_caption,
         image_url:images[0]?.image_url
        }
        return postToSelect
       })
      
      thunkAPI.dispatch(setUserPosts(processedResponse));
    } catch (error) {
      const err = error as { response?: { data?: { error?: string } } };
      return thunkAPI.rejectWithValue(err.response?.data?.error || "Error fetching user posts");
    }
  }
); 